<div class="customers-container">
  <h2>Customers</h2>
  
  <div class="actions-section">
    <button mat-raised-button class="create-btn" (click)="createNewCustomer()">
      <mat-icon>add</mat-icon>
      Create New Customer
    </button>
  </div>
  
  <div class="customers-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading customers...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadCustomers()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search customers</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by name, email, company..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Customers Table -->
      <table mat-table [dataSource]="dataSource" matSort class="customers-table">
        
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
          <td mat-cell *matCellDef="let customer">{{ customer.name || 'Unnamed' }}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let customer">{{ customer.email || '-' }}</td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
          <td mat-cell *matCellDef="let customer">{{ customer.phone || '-' }}</td>
        </ng-container>

        <!-- Company Column -->
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
          <td mat-cell *matCellDef="let customer">{{ customer.company || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editCustomer(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-customers">
              <mat-icon>people</mat-icon>
              <p *ngIf="!input.value">No customers found. Click "Create New Customer" to add your first customer.</p>
              <p *ngIf="input.value">No customers match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator 
        [pageSizeOptions]="[5, 10, 25, 50]" 
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of customers">
      </mat-paginator>
    </div>
  </div>
</div>
